import React from 'react';
import { Link } from 'react-router-dom';
import { PageHeader } from '../components/PageHeader';
import { PricingBlock } from '../components/PricingBlock';
import { FaqList } from '../components/FaqList';
import { TryFreeLink } from '../components/TryFreeLink';
import { faqs } from '../data/faq';
import { pricing, maxProfilesWord } from '../lib/pricing';
const notes = [{
  heading: 'No free trial',
  body: 'Payment is charged when you subscribe. The free sample adventure on this website is separate and needs no account or payment.'
}, {
  heading: 'Yearly is paid upfront',
  body: `The yearly plan charges the full ${pricing.annualPrice} when you subscribe, then once a year when it renews.`
}, {
  heading: 'Renewing and canceling',
  body: 'Subscriptions renew automatically unless canceled in your Apple subscription settings, like any App Store subscription.'
}, {
  heading: 'Up to three children',
  body: `One subscription covers up to ${maxProfilesWord} child profiles, each with its own progress and badges.`
}];
export function Pricing() {
  return <>
      <PageHeader title="Pricing, plainly stated" intro={`Monthly or yearly. Every world, all ${pricing.lessonCount} adventures, up to ${pricing.maxProfiles} children. No ads.`} data-id="element-434" data-mp="1jlb5uxsipe5x" />

      <section aria-label="Plans" className="bg-lavender-soft" data-id="element-435" data-mp="19nwsj71w55hu">
        <div className="mx-auto max-w-4xl px-5 py-16 sm:px-6 md:py-20" data-id="element-436" data-mp="1xcg3xvg8lye5">
          <PricingBlock data-id="element-437" data-mp="1xej06x7zgnrb" />
        </div>
      </section>

      <section aria-labelledby="billing-notes" className="bg-cream" data-id="element-438" data-mp="22bspmcvdgzf5">
        <div className="mx-auto max-w-content px-5 py-16 sm:px-6 md:py-20" data-id="element-439" data-mp="1nmwgsdlhridh">
          <h2 id="billing-notes" className="font-display text-[32px] tracking-tight text-ink md:text-[40px]" data-id="element-440" data-mp="1nkjyfzbtn5zw">
            How billing works
          </h2>
          <div className="mt-10 grid gap-10 md:grid-cols-2 md:gap-12 lg:grid-cols-4" data-id="element-441" data-mp="2ga92kljtvm5q">
            {notes.map(note => <div key={note.heading} className="border-t-[3px] border-ink pt-4" data-id="element-442" data-mp="2l3li866j4imc">
                <h3 className="font-display text-[21px] leading-snug text-ink" data-id="element-443" data-mp="2uwpp6vhyiu0x">{note.heading}</h3>
                <p className="mt-2 text-[17px] text-ink-soft" data-id="element-444" data-mp="2q07nk4hxbbst">{note.body}</p>
              </div>)}
          </div>

          <div className="mt-16 max-w-4xl" data-id="element-445" data-mp="2lvhtml6ts7aj">
            <FaqList items={faqs.filter(faq => faq.billing)} data-id="element-446" data-mp="2gyrd5wr3z9ol" />
          </div>

          <div className="mt-12 flex flex-col items-start gap-5 sm:flex-row sm:items-center" data-id="element-447" data-mp="2bz4ydivmtldo">
            <TryFreeLink data-id="element-448" data-mp="278et05n7hiiz" />
            <p className="text-[17px] text-ink-soft" data-id="element-449" data-mp="2786fcbj9e96q">
              Something unclear about billing?{' '}
              <Link to="/support" className="font-bold text-ink underline decoration-coral decoration-2 underline-offset-4" data-id="element-450" data-mp="228jzrvfykgur">
                Get in touch
              </Link>
              .
            </p>
          </div>
        </div>
      </section>
    </>;
}